if (!customElements.get('product-customize-conditional')) {
  customElements.define(
    'product-customize-conditional',
    class ProductCustomizeConditional extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.panel = this.querySelector('[data-customize-panel]');
        this.nameInput = this.querySelector('[data-customize-input="name"]');
        this.numberInput = this.querySelector('[data-customize-input="number"]');

        try {
          this.config = JSON.parse(this.querySelector('[data-customize-config]')?.textContent || '{}');
        } catch (e) {
          this.config = { linkToOption: false };
        }
        try {
          this.optionsOrder = JSON.parse(this.querySelector('[data-product-options-json]')?.textContent || '[]');
        } catch (e) {
          this.optionsOrder = [];
        }

        this._onVariant = (evt) => {
          const { sectionId, variant } = evt.data || {};
          if (String(sectionId) !== String(this.sectionId)) return;
          this.updateFromVariant(variant);
        };
        this._onOptionSelect = ({ data } = {}) => {
          const target = data?.target;
          if (!this.config.linkToOption || !this.isCustomizeControl(target)) return;
          const value = target.tagName === 'OPTION' ? target.value : target.value;
          this.setPanelVisible(this.isYesValue(value));
        };

        this._unsubVariant =
          typeof subscribe === 'function' ? subscribe(PUB_SUB_EVENTS.variantChange, this._onVariant) : () => {};
        this._unsubOption =
          typeof subscribe === 'function'
            ? subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, this._onOptionSelect)
            : () => {};

        this._onCustomizeClick = (event) => {
          const input = event.target.closest?.('input[type="radio"]');
          if (!input || !this.isCustomizeControl(input)) return;
          this.setPanelVisible(this.isYesValue(input.value));
        };
        this.productRoot = this.closest('product-info') || this.closest('.product') || document;
        this.productRoot.addEventListener('click', this._onCustomizeClick, true);

        this._onNumberInput = this.sanitizeNumberInput.bind(this);
        this.numberInput?.addEventListener('input', this._onNumberInput);

        this.readInitialVariant();
      }

      disconnectedCallback() {
        this._unsubVariant?.();
        this._unsubOption?.();
        this.productRoot?.removeEventListener('click', this._onCustomizeClick, true);
        this.numberInput?.removeEventListener('input', this._onNumberInput);
      }

      isYesValue(value) {
        return String(value || '').trim() === String(this.config.yesValue || 'Yes').trim();
      }

      isCustomizeControl(el) {
        if (!el) return false;
        const optionName = String(this.config.optionName || 'Customize').trim().toLowerCase();
        const node = el.tagName === 'OPTION' ? el.closest('select') || el : el;
        const name = String(node.name || '').toLowerCase();
        if (name.startsWith(`${optionName}-`) || name.includes(`[${optionName}]`)) return true;
        return Boolean(node.closest?.('.product-form__input--customize'));
      }

      readInitialVariant() {
        const script = document.querySelector(
          `variant-selects#variant-selects-${this.sectionId} script[data-selected-variant]`
        );
        if (!script) return;
        try {
          this.updateFromVariant(JSON.parse(script.textContent));
        } catch (e) {}
      }

      optionKeyForCustomize() {
        const target = (this.config.optionName || 'Customize').trim().toLowerCase();
        const idx = this.optionsOrder.findIndex((o) => String(o).trim().toLowerCase() === target);
        if (idx < 0) return null;
        return `option${idx + 1}`;
      }

      updateFromVariant(variant) {
        if (!this.panel) return;

        if (!this.config.linkToOption) {
          this.setPanelVisible(true);
          return;
        }

        const key = this.optionKeyForCustomize();
        if (!key || !variant) {
          this.setPanelVisible(false);
          return;
        }

        this.setPanelVisible(this.isYesValue(variant[key]));
      }

      setPanelVisible(show) {
        if (!this.panel) return;
        if (this.panel.hidden === !show) return;
        this.panel.hidden = !show;
        [this.nameInput, this.numberInput].forEach((el) => {
          if (!el) return;
          el.disabled = !show;
          if (show) {
            if (el.getAttribute('data-required-when-visible') === 'true') el.setAttribute('required', '');
          } else {
            el.removeAttribute('required');
            el.value = '';
          }
        });
      }

      sanitizeNumberInput() {
        if (!this.numberInput || !this.config.numberMaxLength) return;
        const max = parseInt(this.config.numberMaxLength, 10) || 2;
        let v = this.numberInput.value.replace(/\D/g, '');
        if (v.length > max) v = v.slice(0, max);
        this.numberInput.value = v;
      }
    }
  );
}
